import { styled } from '../../utils/styled'

export const StyledLabelContent = styled('span')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  marginLeft: '-8px',

  // The wrapper div for the icon
  '& > div': {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  // The icon itself
  '& svg': {
    fill: 'currentColor'
  }
})
